import Invoices from 'screens/Invoices';
import Invoice from 'screens/Invoices/Invoice';
import InvoiceView from 'screens/Invoices/Invoice/InvoiceView';
import { paths } from 'routes/paths';
import { ROLES } from 'utilities/access';

const navRoutes = [
  {
    id: 'invoices',
    key: 'invoices',
    path: paths.invoices,
    exact: true,
    secure: true,
    disabled: false,
    component: Invoices
  }
];

const allRoutes = [
  ...navRoutes,
  {
    id: 'invoice',
    key: 'invoice',
    path: `${paths.invoices}/:id`,
    exact: true,
    secure: true,
    disabled: false,
    component: Invoice,
    minPermissions: {
      minAllowedRole: ROLES.FULL_CONTROL
    }
  },
  {
    id: 'invoiceDuplicate',
    key: 'invoiceDuplicate',
    path: `${paths.invoices}/:id/duplicate`,
    exact: true,
    secure: true,
    disabled: false,
    component: Invoice,
    minPermissions: {
      minAllowedRole: ROLES.FULL_CONTROL
    }
  },
  {
    id: 'invoiceView',
    key: 'invoiceView',
    path: `${paths.invoices}/:id/:view`,
    exact: true,
    secure: true,
    component: InvoiceView
  }
];

export default { navRoutes, allRoutes };
